import { AlertCircle, Lightbulb, SearchX } from 'lucide-react'

export type BoardStateKind = 'error' | 'empty' | 'no-results'

export type BoardStateProps = {
  kind: BoardStateKind
  onRetry: () => void
  onSubmitIdea: () => void
}

const CONTENT = {
  error: {
    Icon: AlertCircle,
    iconClass: 'text-signal-red',
    title: 'Não foi possível carregar as ideias',
    subtitle:
      'Tivemos um problema ao buscar o roadmap. Verifique sua conexão e tente novamente.',
  },
  empty: {
    Icon: Lightbulb,
    iconClass: 'text-dune-accent',
    title: 'Ainda não há ideias por aqui',
    subtitle:
      'Seja o primeiro a sugerir uma melhoria. As mais votadas viram nossas próximas entregas.',
  },
  'no-results': {
    Icon: SearchX,
    iconClass: 'text-dune-text-secondary',
    title: 'Nenhuma ideia encontrada',
    subtitle: 'Tente outro termo de busca ou remova os filtros.',
  },
} as const

export const BoardState = ({
  kind,
  onRetry,
  onSubmitIdea,
}: BoardStateProps): JSX.Element => {
  const content = CONTENT[kind]
  const { Icon } = content

  return (
    <div className="flex flex-col items-center rounded-2xl border border-dune-border bg-white px-6 py-14 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-dune-bg">
        <Icon className={`h-6 w-6 ${content.iconClass}`} strokeWidth={2} />
      </span>

      <h3 className="mt-4 font-display text-lg font-medium text-dune-text">
        {content.title}
      </h3>

      <p className="mt-1.5 max-w-sm text-sm text-dune-text-secondary">
        {content.subtitle}
      </p>

      {kind === 'error' ? (
        <button
          type="button"
          onClick={onRetry}
          className="mt-5 rounded-2xl border border-dune-border bg-white px-5 py-2.5 font-display text-sm font-medium text-dune-text transition-colors hover:border-dune-accent"
        >
          Tentar novamente
        </button>
      ) : null}

      {kind === 'empty' ? (
        <button
          type="button"
          onClick={onSubmitIdea}
          className="mt-5 rounded-2xl bg-dune-accent px-5 py-2.5 font-display text-sm font-medium text-white transition-colors hover:bg-[#E67700]"
        >
          Enviar a primeira ideia
        </button>
      ) : null}
    </div>
  )
}
